class OfficeDatas {

    constructor() {

        // 通常カレンダー本番
        this.apCalIDListProd = {
            "東京": "sungrove.co.jp_uvli783d0c6rj70akera24hvkc@group.calendar.google.com",
            "大阪": "sungrove.co.jp_i4bi184g2d2r4jkf1mmi7k0suo@group.calendar.google.com",
            "名古屋": "sungrove.co.jp_vk3iaio1bbj7v0um4k5cij65fs@group.calendar.google.com",
            "福岡": "c_6b031d116f3caa2bc73b23e9bcf3454c4c079e8288a2dce93c417f9844da413d@group.calendar.google.com",
            "横浜": "c_e77394d42f0a14cf049a7d4fbb74671eef1ae23a7c5ae5b9b61e4e07ae733ecc@group.calendar.google.com",
            "札幌": "sungrove.co.jp_mafmu1td1t03jlhnn1d1b74o44@group.calendar.google.com",
            "仙台": "sungrove.co.jp_20km5lv3025g3i4076a9doek3g@group.calendar.google.com",
            "広島": "sungrove.co.jp_ki4hedkhssenar4nn4gt8mhsv4@group.calendar.google.com",
            "イツザイエージェント": "c_a3c0b0cbc0c6d6f70bd2de8773f67535f87c993481731d9f6817713e2904b051@group.calendar.google.com",
        }

        // 通常カレンダーテスト
        this.apCalIDListTest = {
            "東京": "c_483e4fe950c8c04707c4cb12f4d53bbd0753c7007061628ac478640d7db0f1b9@group.calendar.google.com",
            "大阪": "c_f2220ec8ed0068fe9c2f0c1517d74756a2ac60c512077be5e63b1d7fa9a8f42e@group.calendar.google.com",
            "名古屋": "c_e551ad887a01c624271ed2efd85db8ed41e6f1832e3aa40fad732ea65810f6f7@group.calendar.google.com",
            "福岡": "c_e3068f2d74b0f8f705e9e16d51ee0578e51ad834cef664d5abbb21f61c2888ee@group.calendar.google.com",
            "横浜": "c_56faf29582ac9b491cf3ef7ec4fe4310f3b9a7f6e258df4517b0e9a111107700@group.calendar.google.com",
            "札幌": "c_1db3a2793c94eaf0d8b0273b530632c6b4dd5910004ac0c4e7009954e3520207@group.calendar.google.com",
            "仙台": "c_23f934320a4b782bf416b7150bc08fb671a656bafbb213ba278e4c26035c9abd@group.calendar.google.com",
            "広島": "c_967d0ce85cfb4093adf44ab8bd754ba3965df711a66c6e5e82dbfb1164e846d4@group.calendar.google.com",
            "イツザイエージェント": "c_b8b522b243266a6b11d4797f8e4e20994009ec4deab96a79e5b4d3e2b3b434c0@group.calendar.google.com",
        }

        // 自アポカレンダー本番
        this.selfSalesCalIDListProd = {
            "東京": "c_hs3vot3t5nh2g1370333i28ido@group.calendar.google.com",
            "大阪": "c_v8dhesj9500eem0k5h9o5k6tv4@group.calendar.google.com",
            "名古屋": "c_bkoq97pc70bb7gjblja3mdiuqk@group.calendar.google.com",
            "福岡": "c_995797969199d3c8a9534e608e9d33582384dd3caf398a4f6f0eaa071c185350@group.calendar.google.com",
            "横浜": "c_d7c6ad291a625342974cc627a5554800394cdea960db541f04b2edf272d6feeb@group.calendar.google.com",
            "札幌": "c_98632f7eb5fdb36cdd48ea0969a0909a55898791bde77cf0c63a2c3268cce57d@group.calendar.google.com",
            "仙台": "c_9f1991eb7b3314c96527dfd816eafa29698af623544ff07e689e360dad88abfb@group.calendar.google.com",
            "広島": "c_f22f9d30e173c7479f2a75ef80206017895049709f12e1a0186c6e1892e97ea9@group.calendar.google.com",
            "イツザイエージェント": "c_ac220a02e61f51a2f3a3fcb3f3985eb108f67f5fa6f526a5081ae2913e8700d8@group.calendar.google.com",
            "JOBYmini": "c_42a3a6e3aa5339148f8d1f8810faf7771df4626ca2c6f54b83cf53e8f4d33891@group.calendar.google.com",
        }

        // 自アポカレンダーテスト
        this.selfSalesCalIDListTest = {
            "東京": "c_01ae38480b65cc955e13e3f8043aeaa975ec4057818de816dde14cd31fc7f411@group.calendar.google.com",
            "大阪": "c_b096ff8c8e5f0cfdb992d048d1f6b1d1c1159ff5cc7562ebcd76ca6883d26e1b@group.calendar.google.com",
            "名古屋": "c_ebb10627549a02ca82b7d8964bbc998b00069e253eb867b6accce78e3dcc8a39@group.calendar.google.com",
            "福岡": "c_c058a0a3f9c760783c6d8a0ebc6b2ef37102f32f98e1b780284569654708dfb9@group.calendar.google.com",
            "横浜": "c_4ecf87eba68930743e38eb9c6a5d3663fc5b7e2d161ad46f5a8891763726c4bd@group.calendar.google.com",
            "札幌": "c_6eb45bcb4e0ac2807a876e4712627652700ea604220ea3aac5d8330bcc2cbbbd@group.calendar.google.com",
            "仙台": "c_27704cb154eceba63de3a5a6a2a118ce6469db4948b84846141d63b9cc9200be@group.calendar.google.com",
            "広島": "c_4fe52620444a19b7d361c43db9d42040792d70ad13f3038da3c3a0426339fd06@group.calendar.google.com",
            "イツザイエージェント": "c_1463d235a22eb1a24217fc15d40c194efa668c5745cbf7259e58916b3ed43cb3@group.calendar.google.com",
            "JOBYmini": "c_70e7a0db6d7755760f1bbca7df90503bafbc721258b6599db26a6a9104af55b0@group.calendar.google.com",
        }

        // 再訪カレンダー本番
        this.saihouCalIDListProd = {
            "東京": "c_kboclvjjfdvspg5ffj6aqut0o0@group.calendar.google.com",
            "大阪": "c_ikpv1a5sm3ugvjdumslq7gjf6c@group.calendar.google.com",
            "名古屋": "c_rbgto9nqiqt9746qmj99bsvat0@group.calendar.google.com",
            "福岡": "c_e9acd590524711b7eccd4bdc65a453cabfa16561b30a482a4b578b4b47c542a9@group.calendar.google.com",
            "横浜": "c_72c40d2517432fc1c0ef7a8b24091704bafb13d426241fbbbdbc354f78762ea4@group.calendar.google.com",
            "札幌": "c_a14a591198bada168d754c7e9f822b2e6942c406aa2cfe3f0f66aec2c55129b7@group.calendar.google.com",
            "仙台": "c_db5c6f16552fb2d44596f37b2a7f4bd8d16e2ad0ff97814968ab0a8611737ecf@group.calendar.google.com",
            "広島": "c_6de4732c9a51c13171bedd35b18fde6e2a1a6723f55bb09764179475d7f274c4@group.calendar.google.com",
            "イツザイエージェント": "c_11205bdaa2dbc117e95f8797831543567879cc8e09611e20de97b09aa0834c8f@group.calendar.google.com",
            "テストマーケ": "c_c3cf85c0c096d608c38aefecb17df3958c70ba9b583f94b62e1032eaee69140b@group.calendar.google.com",
            "JOBY": "c_eada871935451dad54b70035a2e3b655d2275c4a4474b7091fc40c712e1b9271@group.calendar.google.com",
            "JOBYmini": "c_c2e161199768d253ced4fb24897240c71295092c9d8b1e5cfdb4ade75fe5785b@group.calendar.google.com",
        }

        // 再訪カレンダーテスト
        this.saihouCalIDListTest = {
            "東京": "c_8859f44de2db04149c9709adcc0d3a082c1e0164b4b5228127fe2b1e60571524@group.calendar.google.com",
            "大阪": "c_ca9ba5298ab1d7fbbd381874939626e81ba13b783113fb1e4d50ca2457f58a3c@group.calendar.google.com",
            "名古屋": "c_e936a3704b4c527c675b374fc60f0bcf95efbc56ca916757759864dfb85a2763@group.calendar.google.com",
            "福岡": "c_91cc9f0f62ed4352f5c7683e346f172d3adfcd4ffa1f185fc00ce3c414d814e2@group.calendar.google.com",
            "横浜": "c_10f8a9918cb54d027aafea63c59a1240f08ee4ebfbb8fccbdd2a4211ad4e2144@group.calendar.google.com",
            "札幌": "c_acc30fe14a0ca850c5a604e01112f8c5f652063e3f637147ac64fec3b11c4369@group.calendar.google.com",
            "仙台": "c_cc3128b9be68948f705a9a21ec15dfae3e02ff9167d03252b531c843c570db34@group.calendar.google.com",
            "広島": "c_20d4c75d35519cd1738b5acc9e23f9cbafa2a4e1f6921593c046f6364a1d59a1@group.calendar.google.com",
            "イツザイエージェント": "c_613980d4e71e8b69fe1066a2df89e3f71affd46e9c13d6855e2c7902b5f82df2@group.calendar.google.com",
            "テストマーケ": "c_c3cf85c0c096d608c38aefecb17df3958c70ba9b583f94b62e1032eaee69140b@group.calendar.google.com",
            "JOBY": "c_2118e52e4facaf92ec6db439b6228021965004214914bfaf5295fd8c17848757@group.calendar.google.com",
            "JOBYmini": "c_5bdb62ddccd4c5463158cf023585e79f5a2921862a62ce64473dd149e8445042@group.calendar.google.com",
        }

        // リスキャンカレンダー本番
        this.rescanCalIDListProd = [
            "c_uflhjofuk794pidil3ic94itlg@group.calendar.google.com",
            "c_aabd49268c531c04b7a06adea34c51a509831619227bfab4aed7465a9c1dce87@group.calendar.google.com",
            "c_c06bdb245c1ccb1462f386e92c65ec4e94576ac6c775fc88c2f877ba9c5aa51d@group.calendar.google.com",
            "c_f2446df9457a39cd5ef0da8c8b4a15f30890232868e185b0252ff8d017beb7cb@group.calendar.google.com",
        ]

        // リスキャンカレンダーテスト
        this.rescanCalIDListTest = [
            "c_5e1b7b2f286160de612bd4091ed3f37c6dcf2136f4bf931262493e77d613f13a@group.calendar.google.com",
            "c_3277b897a6877b8db0fc2f63cec06b165b9f081c150ef8ad108c28ead167a1c6@group.calendar.google.com",
            "c_c06bdb245c1ccb1462f386e92c65ec4e94576ac6c775fc88c2f877ba9c5aa51d@group.calendar.google.com",
            "c_c66db3c642140ac1e6bba0800616d31472e619bb5237e270a3bff3fccdfde220@group.calendar.google.com",
        ]

        // 商談済みカレンダー本番
        this.negotiationCalIDProd = ["c_493bd765b84eb49989cd9667daaab5e7b48d035a9c63d7a91f0ab4fcd51d11e0@group.calendar.google.com"]

        // 商談済みカレンダーテスト
        this.negotiationCalIDTest = ["c_962044eb9c7bc64acfe06b9a42b8d79ad863b1edf657744d9e65db30abf3f82c@group.calendar.google.com"]

        // 支社IDと支社名の変換用マッピング
        this.officeMapping = {
            1: "東京",
            2: "大阪",
            3: "名古屋",
            4: "福岡",
            5: "秋葉原",
            6: "横浜",
            // 7,8は外部とベトナム
            9: "札幌",
            10: "仙台",
            11: "広島"
        }

        // 本番
        this.calIDListProd = {
            "ap": this.apCalIDListProd,
            "selfSales": this.selfSalesCalIDListProd,
            "saihou": this.saihouCalIDListProd,
            "rescan": this.rescanCalIDListProd,
            "negotiation": this.negotiationCalIDProd
        }

        // テスト
        this.calIDListTest = {
            "ap": this.apCalIDListTest,
            "selfSales": this.selfSalesCalIDListTest,
            "saihou": this.saihouCalIDListTest,
            "rescan": this.rescanCalIDListTest,
            "negotiation": this.negotiationCalIDTest
        }

    }

    checkIncludeCal (calID, type, isProd) {
        const calIDList = isProd ? this.calIDListProd : this.calIDListTest;
        const isIncludeCalID = Object.values(calIDList[type]).includes(calID)
        return isIncludeCalID
    }

    // 支社名受け取ってカレンダーIDを返す（通常アポ）
    getCalID (officeName, type, isProd) {
        const calIDList = isProd ? this.calIDListProd : this.calIDListTest;
        const calList = Object.values(calIDList[type])
        const calID = calList[officeName]
        return calID
    }

    // officeIDから支社名返す
    getUserOfficeName (officeID) {
        let officeName = this.officeMapping[officeID]
        officeName = officeName || ""
        return officeName
    }

}

export default OfficeDatas